import { takeLatest, fork, put, all, call } from 'redux-saga/effects'

import i18n from 'i18n'
import { usersAPI } from 'features/users/api'
import { employerEmployersList } from './slice'
import { RequestUtils } from 'utils'

function* getList({ payload: { params } }) {
  try {
    let requestParams = {
      includes: ['avatar', 'employerProfile'],
    }

    requestParams = RequestUtils.getMapRequestParams(params, requestParams)

    const response = yield call(usersAPI.getEmployers, requestParams)

    const { data } = response

    const {
      meta: { current_page, last_page },
    } = data

    if (current_page && last_page && current_page > last_page) {
      yield put(
        employerEmployersList.getList({
          params: {
            ...params,
            page: last_page,
          },
        })
      )
    } else {
      yield put(employerEmployersList.getListSuccess(data))
    }
  } catch (error) {
    const message = error.response?.data?.message || i18n.t('error')
    yield put(employerEmployersList.getListError(message))
  }
}

function* watchGetList() {
  yield takeLatest(employerEmployersList.getList, getList)
}

export function* listSaga() {
  yield all([fork(watchGetList)])
}
